export const booleanInputStyle = {
  '& .MuiFormControlLabel-root': { flexDirection: 'row-reverse', mx: 0 },
  '& .MuiFormControlLabel-label': { mr: 'auto' },
} as const;
